/* Email-verified COA download (snippets/rp-coa-download.liquid).
   Builds one modal, posts the lead to the COA gate Worker, which emails a confirmation link.
   The Worker enforces everything (CORS, Turnstile, rate limit, honeypot); this file is only UI. */
(function () {
  if (window.__rpCoaGate) return;
  window.__rpCoaGate = true;

  var API = window.RP_COA_GATE_API || 'https://rite-coa-gate.trywholesome.workers.dev';
  var cfg = null, cfgPromise = null, dlg = null, current = null, tsToken = '', tsId = null, tsLoading = false, opener = null;

  function store(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) {} return null; }
  var preview = /[?&]coa_gate=preview(&|$)/.test(location.search);
  if (preview) store('rpCoaGatePreview', '1');
  preview = preview || store('rpCoaGatePreview') === '1';

  function loadConfig() {
    if (!cfgPromise) {
      cfgPromise = fetch(API + '/config', { mode: 'cors' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; })
        .then(function (c) { cfg = c; return c; });
    }
    return cfgPromise;
  }

  // Reveal every download button only when the Worker says the gate is live (or in preview mode).
  loadConfig().then(function (c) {
    if (c && (c.enabled || preview)) document.documentElement.classList.add('rp-coa-gate-on');
  });

  function el(tag, attrs, html) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) { n.setAttribute(k, attrs[k]); });
    if (html != null) n.innerHTML = html;
    return n;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function q(sel) { return dlg.querySelector(sel); }

  function build() {
    dlg = el('dialog', { class: 'rpx rpx-dlg', 'aria-labelledby': 'rp-dl-title' });
    dlg.innerHTML =
      '<button type="button" class="rpx-dlg__close" data-close aria-label="Close">&times;</button>' +
      '<div class="rpx-dlg__body">' +
        '<div data-view="form">' +
          '<p class="rpx-dlg__kicker">Certificate of analysis</p>' +
          '<h2 class="rpx-dlg__title" id="rp-dl-title">Download the COA (PDF)</h2>' +
          '<p class="rpx-dlg__lot"><span data-product></span><span data-sep> &middot; </span>Lot <code data-lot></code></p>' +
          '<p class="rpx-dlg__lede" data-lede></p>' +
          '<form class="rpx-dlg__form" novalidate>' +
            '<div class="rpx-field"><label for="rp-dl-email">Email</label><input id="rp-dl-email" name="email" type="email" required autocomplete="email" spellcheck="false" inputmode="email"></div>' +
            '<div class="rpx-field"><label for="rp-dl-phone">Phone <span class="rpx-field__opt">(optional)</span></label><input id="rp-dl-phone" name="phone" type="tel" autocomplete="tel" inputmode="tel"></div>' +
            '<label class="rpx-dlg__check" for="rp-dl-sms"><input id="rp-dl-sms" name="sms_consent" type="checkbox"><span>Text me about this COA request. Message and data rates may apply. Reply STOP to opt out.</span></label>' +
            '<div class="rpx-dlg__hp" aria-hidden="true"><label>Website<input type="text" name="website" tabindex="-1" autocomplete="off"></label></div>' +
            '<div class="rpx-dlg__ts" data-ts></div>' +
            '<p class="rpx-dlg__err" role="alert" data-err hidden></p>' +
            '<button type="submit" class="rpx-btn rpx-btn--primary rpx-dlg__submit"><span>Email me the link</span></button>' +
            '<p class="rpx-dlg__fine">We use your email only to send this report and to follow up about it. See our <a href="/policies/privacy-policy">privacy policy</a>. Supplied as laboratory research material only.</p>' +
          '</form>' +
        '</div>' +
        '<div data-view="done" hidden tabindex="-1">' +
          '<p class="rpx-dlg__kicker" data-done-kicker></p>' +
          '<h2 class="rpx-dlg__title" data-done-title></h2>' +
          '<p class="rpx-dlg__lede" data-done-text></p>' +
          '<button type="button" class="rpx-btn rpx-btn--secondary" data-close>Close</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(dlg);

    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || (e.target.closest && e.target.closest('[data-close]'))) close();
    });
    dlg.addEventListener('close', function () { document.documentElement.classList.remove('rp-coa-dlg-open'); if (opener && opener.focus) opener.focus(); });
    q('form').addEventListener('submit', submit);
  }

  function showErr(msg) { var e = q('[data-err]'); e.textContent = msg || ''; e.hidden = !msg; }
  function close() { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); document.documentElement.classList.remove('rp-coa-dlg-open'); }

  function mountTurnstile() {
    var key = cfg && cfg.turnstile_site_key;
    var box = q('[data-ts]');
    if (!key || !box) return;
    function render() {
      if (tsId !== null && window.turnstile) { try { window.turnstile.reset(tsId); } catch (e) {} tsToken = ''; return; }
      if (!window.turnstile) return;
      tsId = window.turnstile.render(box, {
        sitekey: key, theme: 'dark', size: 'flexible',
        callback: function (t) { tsToken = t; },
        'expired-callback': function () { tsToken = ''; },
        'error-callback': function () { tsToken = ''; }
      });
    }
    if (window.turnstile) return render();
    if (tsLoading) return;
    tsLoading = true;
    var s = document.createElement('script');
    s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    s.async = true; s.defer = true;
    s.onload = render;
    document.head.appendChild(s);
  }

  function open(btn) {
    opener = btn;
    current = { lot: btn.getAttribute('data-lot'), product: btn.getAttribute('data-product') || '' };
    loadConfig().then(function () {
      if (!dlg) build();
      q('[data-view="form"]').hidden = false;
      q('[data-view="done"]').hidden = true;
      q('form').reset();
      showErr('');
      q('[data-product]').textContent = current.product;
      q('[data-sep]').hidden = !current.product;
      q('[data-lot]').textContent = current.lot;
      var have = cfg && cfg.available_lots && cfg.available_lots.indexOf(current.lot) !== -1;
      q('[data-lede]').textContent = have
        ? 'Enter your email and we will send a confirmation link. Open it to download the PDF for this lot.'
        : 'The report for this lot is not posted yet. Leave your email and we will send it as soon as it is ready.';
      q('.rpx-dlg__submit span').textContent = have ? 'Email me the link' : 'Notify me when it is ready';
      document.documentElement.classList.add('rp-coa-dlg-open');
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      mountTurnstile();
      var email = q('#rp-dl-email'); if (email) email.focus();
    });
  }

  function done(kicker, title, text) {
    q('[data-view="form"]').hidden = true;
    var v = q('[data-view="done"]');
    v.hidden = false;
    q('[data-done-kicker]').textContent = kicker;
    q('[data-done-title]').textContent = title;
    q('[data-done-text]').innerHTML = text;
    v.focus();
  }

  function submit(ev) {
    ev.preventDefault();
    var form = ev.target;
    var email = form.email.value.trim();
    var phone = form.phone.value.trim();
    var consent = form.sms_consent.checked;
    showErr('');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { showErr('Enter a valid email address.'); form.email.focus(); return; }
    if (phone && !consent) { showErr('Check the box to allow texts, or clear the phone number.'); form.sms_consent.focus(); return; }
    if (cfg && cfg.turnstile_site_key && !tsToken) { showErr('Please wait for the security check to finish, then try again.'); return; }
    var btn = form.querySelector('button[type="submit"]');
    btn.disabled = true; btn.setAttribute('aria-busy', 'true');
    fetch(API + '/api/request', {
      method: 'POST', mode: 'cors', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email, phone: phone, sms_consent: consent, lot: current.lot, website: form.website.value, cf_token: tsToken, source: location.href })
    }).then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, status: r.status, body: j }; }); })
      .then(function (res) {
        if (!res.ok || !res.body.ok) {
          showErr(res.body.message || (res.status === 429 ? 'Too many requests. Please try again later.' : 'Something went wrong. Please try again.'));
          if (window.turnstile && tsId !== null) { try { window.turnstile.reset(tsId); } catch (e) {} tsToken = ''; }
          return;
        }
        var who = '<strong>' + esc(email) + '</strong>';
        if (res.body.status === 'verification_sent') {
          done('Check your email', 'Confirmation link sent', 'We sent a link to ' + who + '. Open it to confirm your email and download the COA for lot ' + esc(current.lot) + '. The link works for 24 hours. If you do not see it, check your spam folder.');
        } else if (res.body.status === 'coming_soon_sent') {
          done('COA coming soon', 'We will send it when it is ready', 'The report for lot ' + esc(current.lot) + ' is not posted yet. We emailed ' + who + ' to confirm your request, and we will send the COA as soon as it is available.');
        } else {
          done('Request saved', 'We have your request', 'We saved your request for lot ' + esc(current.lot) + ', but could not send the email just now. We will follow up at ' + who + ' with the COA.');
        }
      })
      .catch(function () { showErr('Network error. Please check your connection and try again.'); })
      .then(function () { btn.disabled = false; btn.removeAttribute('aria-busy'); });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-rp-coa-dl]');
    if (!b) return;
    e.preventDefault();
    open(b);
  });
})();
